'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Hock = require('../util/Hock');

var _Hock2 = _interopRequireDefault(_Hock);

var _elementResizeDetector = require('element-resize-detector');

var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var erd = null;

if (typeof window !== 'undefined') {
    // Don't try to detect resize events on server
    erd = (0, _elementResizeDetector2.default)({ strategy: "scroll" });
}

/**
 * @module Hocks
 */

var ElementQueryHock = function ElementQueryHock(config) {
    var eqs = config.eqs;
    return function (ComposedComponent) {

        /**
         * @component
         *
         * ElementQueryHock is designed to allow components to respond to the size of their
         * containing element rather than to the size of the window. When used on a component,
         * your component will receive some extra props.
         *
         * @example
         * const example = (props) => {
         *     if(!props.eqReady) return <div>No data yet</div>;
         *     return <div>
         *         <div>width: {props.eqWidth}</div>
         *         <div>height: {props.eqHeight}</div>
         *         <div>active queries: {props.eqActive.join(', ')}</div>
         *         <div>inactive queries: {props.eqInactive.join(', ')}</div>
         *     </div>
         * }
         *
         * const ElementQueryHockExample = ElementQueryHock([
         *     {
         *         name: 'medium',
         *         widthBounds: [300, 600],
         *         heightBounds: [200, 400]
         *     },
         *     {
         *         name: 'large',
         *         widthBounds: [600, 1200],
         *         heightBounds: [400, 1800]
         *     }
         * ])(example);
         *
         * @decorator {ElementQueryHock}
         *
         * @childprop {number}
         * eqWidth The current width of the parent element.
         *
         * @childprop {number} eqHeight
         * The current height of the parent element.
         *
         * @childprop {Array<string>} eqActive
         * An array of currently active queries.
         *
         * @childprop {Array<string>} eqInactive
         * An array of currently inactive queries.
         *
         * @childprop {boolean} eqReady
         * A boolean that can be used to determine whether the ElementQueryHock has been able
         * to read the parent node's height and width yet.
         *
         * @memberof module:Hocks
         */

        var ElementQueryHock = function (_React$Component) {
            (0, _inherits3.default)(ElementQueryHock, _React$Component);

            function ElementQueryHock(props) {
                (0, _classCallCheck3.default)(this, ElementQueryHock);

                var _this = (0, _possibleConstructorReturn3.default)(this, (ElementQueryHock.__proto__ || (0, _getPrototypeOf2.default)(ElementQueryHock)).call(this, props));

                _this.handleResize = _this.handleResize.bind(_this);
                _this.mounted = false;
                _this.state = {
                    ready: false,
                    active: [],
                    inactive: []
                };
                return _this;
            }

            (0, _createClass3.default)(ElementQueryHock, [{
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.mounted = true;
                    if (erd && this.wrapper) {
                        var container = this.wrapper.parentNode;
                        erd.listenTo(container, this.handleResize);
                        this.handleResize(container);
                    }
                }
            }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.mounted = false;
                    if (erd && this.wrapper) {
                        erd.removeListener(this.wrapper.parentNode, this.handleResize);
                    }
                }
            }, {
                key: 'checkIfActive',
                value: function checkIfActive() {
                    var widthBounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                    var heightBounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                    var width = arguments[2];
                    var height = arguments[3];

                    return width >= (widthBounds[0] || 0) && width < (widthBounds[1] || Infinity) && height >= (heightBounds[0] || 0) && height < (heightBounds[1] || Infinity);
                }
            }, {
                key: 'handleResize',
                value: function handleResize(element) {
                    if (!this.mounted) {
                        return;
                    }

                    // This method uses native es3 js functionality for (admittedly minute) performance
                    // improvements. Seeing as this method is called alotta times it is (probably) worth it
                    var width = element.clientWidth;
                    var height = element.clientHeight;

                    if (width === this.state.width && height === this.state.height) return;

                    var updated = false;
                    var active = [];
                    var inactive = [];
                    var eqList = eqs();

                    for (var i = 0; i < eqList.length; i++) {
                        var eq = eqList[i];
                        if (this.checkIfActive(eq.widthBounds, eq.heightBounds, width, height)) {
                            if (this.state.active.indexOf(eq.name) === -1) {
                                updated = true;
                            }
                            active.push(eq.name);
                        } else {
                            if (this.state.inactive.indexOf(eq.name) === -1) {
                                updated = true;
                            }
                            inactive.push(eq.name);
                        }
                    }

                    // Don't change active and inactive arrays if nothing changed (stops unnecessary rerenders)
                    if (!updated) {
                        active = this.state.active;
                        inactive = this.state.inactive;
                    }

                    this.setState({ width: width, height: height, active: active, inactive: inactive, ready: true });
                }
            }, {
                key: 'render',
                value: function render() {
                    var _this2 = this;

                    return _react2.default.createElement(
                        'span',
                        { ref: function ref(ii) {
                                return _this2.wrapper = ii;
                            } },
                        _react2.default.createElement(ComposedComponent, (0, _assign2.default)({}, this.props, {
                            eqWidth: this.state.width,
                            eqHeight: this.state.height,
                            eqActive: this.state.active,
                            eqInactive: this.state.inactive,
                            eqReady: this.state.ready
                        }))
                    );
                }
            }]);
            return ElementQueryHock;
        }(_react2.default.Component);

        return ElementQueryHock;
    };
};

/**
 * Provides configuration for `ElementQueryHock`.
 *
 * @callback ElementQueryHock
 *
 * @param {Array<ElementQueryObject>} eqs An array of element queries to check for.
 *
 * @return {ElementQueryWrapper}
 */

/**
 * A function that accepts the component you want to wrap in a `ElementQueryHock`.
 *
 * @callback ElementQueryWrapper
 *
 * @param {ReactComponent} ComponentToDecorate
 * The component you wish to wrap in an `ElementQueryHock`.
 *
 * @return {ReactComponent}
 * The decorated component.
 */

/**
 * @typedef ElementQueryObject
 *
 * @property {String} name
 * The name of the element query.
 *
 * @property {Number[]} [widthBounds=[0, Infinity]]
 * An array containing two values for the minimum (inclusive) and maximum (exclusive)
 * widths allowed by this element query. If the second array item is excluded it is
 * assumed that there is no maximum.
 *
 * @property {Number[]} [heightBounds=[0, Infinity]]
 * An array containing two values for the minimum (inclusive) and maximum (exclusive)
 * heights allowed by this element query. If the second array item is excluded it is
 * assumed that there is no maximum.
 */

exports.default = (0, _Hock2.default)({
    hock: ElementQueryHock,
    defaultConfig: {
        eqs: function eqs() {
            return [];
        }
    },
    shorthandKey: "eqs"
});


//////////////////
// WEBPACK FOOTER
// ./~/stampy/lib/hock/ElementQueryHock.js
// module id = 895
// module chunks = 35783957827783